export default __webpack_public_path__ + "897fc4a995d87d15b0e95a06e0f421b7.svg";